import React, { FC } from 'react';
import { getIn } from 'formik';

import { CircularProgress } from '@mui/material';

import { useFuturesTradeAccountsQuery } from '../../hooks';
import FormikAutocomplete from '../FormikAutocomplete/FormikAutocomplete';

export interface FuturesTradeAccountAutocompleteProps {
  formik: any;
  openOnFocus?: boolean;
}

const FuturesTradeAccountAutocomplete: FC<FuturesTradeAccountAutocompleteProps> = (props) => {
  const allOptions = useFuturesTradeAccountsQuery().data;
  if (!allOptions) {
    return <CircularProgress />;
  }
  let activeOptions = allOptions
    .filter((t) => t.isActiveInFutures)
    .sort((a, b) => (a.tradeAccountName ?? '').localeCompare(b.tradeAccountName ?? ''));

  let optionsById = new Map(
    activeOptions?.map((ta) => [ta.tradeAccountId as number, ta.tradeAccountName as string])
  );

  const value = getIn(props.formik.values, 'tradeAccountId');
  if (value && !optionsById.get(value)) {
    const missingOption = allOptions.find((t) => t.tradeAccountId === value);
    if (missingOption) {
      activeOptions = [...activeOptions, missingOption];
      optionsById = new Map(
        activeOptions?.map((ta) => [ta.tradeAccountId as number, ta.tradeAccountName as string])
      );
    }
  }

  return (
    <FormikAutocomplete
      formik={props.formik}
      openOnFocus={props.openOnFocus}
      field="tradeAccountId"
      optionsAsMap={optionsById}
    ></FormikAutocomplete>
  );
};

export default FuturesTradeAccountAutocomplete;
